var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import * as React from 'react';

function SvgLoneStar(props) {
  return React.createElement("svg", __assign({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), React.createElement("path", {
    d: "M7.247 6.346L10.104.557a1 1 0 011.794 0l2.857 5.79 6.39.934a1 1 0 01.554 1.705l-4.623 4.503 1.09 6.362a1 1 0 01-1.45 1.054L11 17.9l-5.714 3.005a1 1 0 01-1.452-1.054l1.092-6.362L.303 8.986a1 1 0 01.553-1.705l6.39-.935z",
    fill: "#f8bb40",
    fillRule: "nonzero"
  }));
}

export default SvgLoneStar;